import './style.scss';

import React, { useEffect, useState } from 'react';
import { Accordion, Col, Container, Row } from 'react-bootstrap';
import { BookingFilter } from 'types/booking';
import { Client } from 'types/user';

import { FilterMap, FilterParams, FilterStruct } from '../../types/styling';
import Filter from './Filter';

interface IFilters {
    loadFilters?: (user_uuid: string) => void;
    filters: FilterStruct[];
    selected: Record<string, any>;
    showSelection: boolean;
    setFilter: (input: FilterParams | BookingFilter) => void;
    clearFilter?: (input: string) => void;
    user: Client | undefined;
    className: string;
    filterSubmited?: boolean;
}

const Filters: React.FC<IFilters> = ({
    loadFilters = undefined,
    filters = [],
    selected = {},
    showSelection = false,
    setFilter,
    clearFilter,
    user,
    className = '',
    filterSubmited
}) => {
    const [collapsed, setCollapsed] = useState(['pending', 'client']);

    const isDisabled = (filter: any) =>
        (!filter.filter_options || !filter.filter_options.length) &&
        (!filter.filters || !filter.filters.length) &&
        getFilterType(filter.key) !== 'slider';

    const setCollapsedFilters = (key: string) => {
        if (collapsed.includes(key)) {
            setCollapsed(collapsed.filter((item) => item !== key));
        } else {
            setCollapsed([...collapsed, key]);
            if (key === 'sortBy' || key === 'pricingModel') {
                setTimeout(() => {
                    const elm = document.getElementsByClassName('dropdown-menu show')[0];
                    if (elm) elm.scrollTo({ top: 800, behavior: 'smooth' });
                }, 300);
            }
        }
    };

    const getFilterType = (key: string) => {
        let type = 'checkbox';
        if (key === 'budget') type = 'slider';
        if (key.toLowerCase().includes('brand')) type = 'search';
        return type;
    };

    useEffect(() => {
        if (!filters.length && user && loadFilters) {
            loadFilters(user.user_uuid as string);
        }
    }, [user]);

    const hasFilter = (key: string) => Object.keys(selected).includes(key);

    return (
        <Container className={`filters no-padding ${className}`} fluid>
            <Row className="filters-container">
                <Col>
                    <Accordion className="filters-list">
                        {filters.map(
                            (filter) =>
                                filter.key && (
                                    <Filter
                                        disabled={isDisabled(filter)}
                                        key={filter.key}
                                        type={getFilterType(filter.key)}
                                        filter={filter as FilterMap}
                                        selected={
                                            filter.key
                                                ? filter.key === 'budget'
                                                    ? [
                                                          {
                                                              key: 'minPrice',
                                                              value: selected.minPrice
                                                                  ? selected.minPrice[0]?.key
                                                                  : selected.min_budget
                                                                  ? selected.min_budget[0]?.key
                                                                  : 1
                                                          },
                                                          {
                                                              key: 'maxPrice',
                                                              value: selected.maxPrice
                                                                  ? selected.maxPrice[0]?.key
                                                                  : selected.max_budget
                                                                  ? selected.max_budget[0]?.key
                                                                  : 5000
                                                          }
                                                      ]
                                                    : selected[filter.key]
                                                : []
                                        }
                                        onClick={() => setCollapsedFilters(filter.key)}
                                        onChange={setFilter}
                                        onClear={clearFilter}
                                        isCollapsed={collapsed.includes(filter.key)}
                                        showSelection={
                                            getFilterType(filter.key) === 'slider'
                                                ? false
                                                : showSelection
                                        }
                                        categorySingleSelect={
                                            filter.hasOwnProperty('isMulti')
                                                ? !filter.isMulti
                                                : null
                                        }
                                        categoryHasFilterSelected={hasFilter(filter.key)}
                                        isfilterSubmited={filterSubmited}
                                        isSort={filter.key === 'sortBy'}
                                    />
                                )
                        )}
                    </Accordion>
                </Col>
            </Row>
        </Container>
    );
};

export default Filters;
